import { useEffect, useMemo, useRef } from 'react';

import type { SearchPageActiveFilter } from './sharedTypes';

export const useScrollToSearchResultsOnActiveFilterChange = <FilterName extends string>(
  activeFilters: SearchPageActiveFilter<FilterName>[]
) => {
  const resultsRef = useRef<HTMLDivElement>(null);
  const activeFiltersSignature = useMemo(
    () =>
      activeFilters
        .map((activeFilter) =>
          activeFilter.type === 'filter'
            ? `${activeFilter.type}:${activeFilter.filterName}:${activeFilter.value}`
            : `${activeFilter.type}:${activeFilter.value}`
        )
        .join('|'),
    [activeFilters]
  );
  const previousActiveFiltersSignatureRef = useRef<string | null>(null);

  useEffect(() => {
    const previousSignature = previousActiveFiltersSignatureRef.current;
    previousActiveFiltersSignatureRef.current = activeFiltersSignature;

    if (previousSignature === null || previousSignature === activeFiltersSignature) {
      return;
    }

    resultsRef.current?.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }, [activeFiltersSignature]);

  return resultsRef;
};
